var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6Card1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_6988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.99967H13.0133C12.7219 7.99905 12.4384 8.09388 12.206 8.26965C11.9736 8.44543 11.8053 8.69247 11.7266 8.97301L10.1599 14.5463C10.1498 14.581 10.1288 14.6114 10.0999 14.633C10.0711 14.6546 10.036 14.6663 9.99992 14.6663C9.96386 14.6663 9.92877 14.6546 9.89992 14.633C9.87107 14.6114 9.85002 14.581 9.83992 14.5463L6.15992 1.45301C6.14982 1.41839 6.12877 1.38798 6.09992 1.36634C6.07107 1.3447 6.03598 1.33301 5.99992 1.33301C5.96386 1.33301 5.92877 1.3447 5.89992 1.36634C5.87107 1.38798 5.85002 1.41839 5.83992 1.45301L4.27325 7.02634C4.1949 7.30578 4.02751 7.55202 3.79649 7.72768C3.56548 7.90335 3.28347 7.99884 2.99325 7.99967H1.33325",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_6988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6Card1);
export default __webpack_public_path__ + "static/media/Icon6card1.698dd9a759b87d9ed8bbace5e2249aa0.svg";
export { ForwardRef as ReactComponent };